module.exports = __webpack_public_path__ + "img/n1.fc2f2738.png";